import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";
import { aikaPvmStringLong } from "src/components/js/statics1";
import MySwitch from "src/components/MySwitch/MySwitch";
import { isKeikkaHandler } from "src/data/ifs/isIfs";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useUserData } from "src/context/userContext";
import { useStepLogData } from "src/context/StepLogContext";
import { lazy } from "react";
import { Grid, Typography } from "@mui/material";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const MuokkaustilaButton = lazy(() =>
  import("src/components/buttons/purposed/MuokkaustilaButton/MuokkaustilaButton")
);

const styles = {
  tilausLeft: { paddingRight: "5px", height: "30px" },
  varmenneLeft: { paddingRight: "5px", height: "25px" },
  tilausRright: { height: "30px" },
  varmenneRight: { height: "25px" },
  varmenneRightPrint: { paddingLeft: "5px", paddingTop: "4px" },
  textRight: { textAlign: "right" },
  flex: { display: "flex" },
  tarjousTilaus: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "6px",
  },
  tarjousPyyntoText: { opacity: 0.3 },
  tarjousTilausSwitchWidth: { width: "275px" },
};

export default function TilausnumeroRow(props) {
  const { user } = useUserData();
  const { keikkaData } = useKeikkaData();
  const { stepLog } = useStepLogData();
  const keikkaId = keikkaData.keikkaId;
  const varmenne = keikkaData.varmenne;

  return (
    <>
      <Grid container sx={{ width: "100%" }}>
        <Grid size={{ xs: 3 }} sx={styles.textRight}>
          <Typography
            variant="h6"
            sx={styles.tilausLeft}
            color="primary"
            component="div"
            noWrap
            className="fixPrint">
            Tilaus:
          </Typography>
          {varmenne && (
            <Typography
              variant="h7"
              sx={styles.varmenneLeft}
              color="primary"
              component="div"
              className="fixPrint"
              noWrap>
              Varmenne:
            </Typography>
          )}
          <Typography
            variant="body2"
            sx={styles.varmenneLeft}
            color="primary"
            component="div"
            className="onlyPrint"
            noWrap>
            https://
          </Typography>
        </Grid>
        <Grid size={{ xs: 9 }}>
          <Grid container sx={{ width: "100%" }}>
            <Grid size={{ xs: 4 }}>
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h6"
                  color="primary"
                  component="div"
                  className="fixPrint "
                  sx={styles.tilausRright}>
                  {keikkaId == 0 ? "Ladataan" : keikkaId}
                </Typography>
                <Typography
                  variant="body"
                  color="primary"
                  component="div"
                  className="fixPrint onlyWide"
                  noWrap
                  style={{
                    paddingLeft: "5px",
                    paddingTop: "5px",
                    opacity: 0.8,
                  }}
                  sx={styles.tilausRright}>
                  {keikkaData?.foreignKey &&
                    keikkaData.foreignKey.length > 0 &&
                    " / " + keikkaData.foreignKey}
                </Typography>
              </div>
              {keikkaData.isLoading ? (
                <MySkeleton width="45px" height="25px" />
              ) : (
                <div style={styles.flex}>
                  <Typography
                    variant="h7"
                    color="primary"
                    className="fixPrint "
                    component="div"
                    sx={styles.varmenneRight}>
                    {varmenne}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    className="onlyPrint"
                    sx={styles.varmenneRightPrint}
                    component="div">
                    {"/ " + aikaPvmStringLong(new Date(), true)}
                  </Typography>
                </div>
              )}
              <Typography
                variant="body2"
                color="primary"
                className="onlyPrint"
                component="div"
                sx={styles.varmenneRight}>
                betoni.online/tilaus/{keikkaId}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6 }}></Grid>
            <Grid size={{ xs: 2 }} style={styles.tarjousTilaus}>
              {stepLog && (
                <>
                  {keikkaData.auth.isKeikkaAdmin
                    ? renderTarjousTilausText()
                    : renderTarjousTilausSwitch()}
                </>
              )}
              {isKeikkaHandler(keikkaData, user, stepLog) && (
                <LazyLoader>
                  <MuokkaustilaButton show />
                </LazyLoader>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
  function renderTarjousTilausText() {
    if (stepLog.isTarjouspyyntö)
      return (
        <div style={styles.tarjousPyyntoText}>
          <Typography variant="h4" color="primary">
            TARJOUSPYYNTÖ
          </Typography>
        </div>
      );
    return null;
  }
  function renderTarjousTilausSwitch() {
    if (keikkaData.tila.keikkaTilaId !== 0) return null;
    if (keikkaData.isLoading) return null;
    const _helpId = "tarjousTilausSwitch-" + (props.isTarjouspyyntöChecked ? "Tarjous" : "Tilaus");

    return (
      <div className="noPrint">
        <div style={styles.tarjousTilaus}>
          <div style={styles.tarjousTilausSwitchWidth}>
            <MySwitch
              leftSide="tarjouspyyntö"
              rightSide="tilaus"
              checked={!props.isTarjouspyyntöChecked}
              onChange={(e) => props.setIsTarjouspyyntö(!e)}
              helpId={_helpId}
            />
          </div>
        </div>
      </div>
    );
  }
}

TilausnumeroRow.propTypes = {
  origVarmenne: PropTypes.string,
  isTarjouspyyntöChecked: PropTypes.bool,
  setIsTarjouspyyntö: PropTypes.func,
};
